<template>
	<date-picker
		v-model="datetime"
		ref="datepicker"
		type="date"
		format="DD.MM.YYYY"
		range
	></date-picker>
</template>

<script>
import VxInputGroup from "@/components/vx-input-group/VxInputGroup";
import VsCustomButton from "@/components/vs-custom-button/VsCustomButton";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
	name: "VsDatepickerRange",
	components: { VsCustomButton, DatePicker, VxInputGroup },
	props: {
		value: {
			required: true
		}
	},
	computed: {
		datetime: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (this.$refs.datepicker) {
				this.$refs.datepicker.locale.formatLocale.monthsShort = [
					"Jan",
					"Feb",
					"März",
					"Apr",
					"Mai",
					"Juni",
					"Juli",
					"Aug",
					"Sept",
					"Okt",
					"Nov",
					"Dez"
				];
			}
		});
	}
};
</script>

<style lang="scss">
.mx-datepicker-main {
	.mx-calendar-content .cell.active {
		background-color: rgba(var(--vs-primary), 1);
	}

	.mx-calendar-content .cell.in-range,
	[dir] .mx-calendar-content .cell.hover-in-range {
		background-color: rgba(var(--vs-primary), 0.6);
		color: white;
	}

	.mx-calendar-content .cell.cell.hover-in-range {
		background-color: rgba(var(--vs-primary), 0.7);
		color: white;
	}

	.mx-calendar-content .cell:hover {
		background-color: rgba(var(--vs-primary), 0.8);
		color: white;
	}
	.mx-table-date .today {
		color: rgba(black, 1);
		font-weight: bold;
	}
	.mx-table-date .today.active {
		color: white;
	}
}
.mx-datepicker.mx-datepicker-range {
	.mx-input {
		height: 37.5px;
	}
	.mx-input:hover,
	.mx-input:focus {
		border-color: rgba(var(--vs-primary), 1);
	}
}
</style>
